import React from 'react';
import useStyle from './challengeBanner.style';
import { getChallengeName } from '../../../../helpers/challenge/getChallengeName';

export interface ChallengeBannerProps {
  season?: 'default' | 'autumn' | 'spring';
  year?: string;
}

export const ChallengeBanner = ({
  season = 'autumn',
  year = '2022'
}: ChallengeBannerProps) => {
  const classes = useStyle();

  return (
    <div className={`${classes.root} ${classes[season]}`}>
      <span>{getChallengeName(season, year)}</span>
    </div>
  );
};
